module.exports = __webpack_public_path__ + "static/img/food-policy013.66bd21c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/food-policy013.png
// module id = HBII
// module chunks = 1